<template>
    <div :class="isMobile==0?'':'bottomtext_mobile'" class="bottomtext" style="position: relative;">
        <div @click="ogo()" class="line_font" v-if="lang.fyType == 2">Login to receive our newsletter</div>
        <div @click="ogo()" class="line_font" v-else>登录以接收我们的最新消息</div>
        <div @click="ogo()" class="line_font lf_sp_sp" v-if="lang.fyType == 2" style="">Latest information on CHOISI
            activities</div>
        <div @click="ogo()" class="line_font lf_sp_sp" v-else>最新消息：CHOISI活动最新信息</div>
        <div :class="isMobile==0?'':'bt_line_mobile'"class="bt_line"></div>
        <a class="a_bt_sp" v-if="ifShow&&isMobile==0" href="https://beian.miit.gov.cn">沪ICP备2025145205号</a>
    </div>
</template>

<script>
import router from '@/router';
export default {
    name: 'Bottom',
    props: {
        ifShow: Boolean
    },
    data() {
        return {
            lang: {},
            isMobile:0
        }
    },
    watch: {
        // 2. 监听响应式变量 currentLang 的变化（深度监听对象内部属性）
        lang: {
            handler(newLang, oldLang) {
                console.log('Lang 变化了：', newLang);
            },
            deep: true, // 关键：监听对象内部属性（如 Lang/fyType）的变化
            immediate: true // 可选：组件初始化时就执行一次监听逻辑（避免首次加载无数据）
        }
    },
    mounted() {
        this.isMobile=localStorage.getItem('isMobile')
        this.lang = JSON.parse(localStorage.getItem('Lang'))
        window.addEventListener('langChange', () => {
            this.syncLangFromStorage(); // 同步最新语言到响应式变量（触发 watch）
        });
    },
    methods: {
        ogo() {
            router.push({
                path: `/contact-us`
            });
        },
        syncLangFromStorage() {
            this.lang = JSON.parse(localStorage.getItem('Lang'))
        }
    }
}
</script>

<style>
.bottomtext {
    box-sizing: border-box;
    width: 100%;
    height: 120px;
    background: #6488C6;
    text-align: left;
    padding-top: 30px;
    padding-left: 14.5%;
}
.bottomtext_mobile{
    padding-bottom: 20px;
    width: 100%;
    padding-right: 5px;
    box-sizing: border-box;
    padding-top: 20px;
    padding-left: 20px;
}
.line_font {
    opacity: 90%;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
}

.lf_sp_sp {
    margin: 5px 0px 16px;
}

.bt_line {
    width: 500px;
    height: 1px;
    border-top: 1px solid #FFFFFF;
}
.bt_line_mobile{
    width: 300px;
}
.a_bt_sp {
    text-align: center;
    color: white;
    font-size: 20px;
    position: absolute;
    right: 20%;
    top: 50%;
    transform: translate(0, -50%);
    z-index: 99;
}
</style>